export const DL_START = 'DL_START';
export const DL_PROGRESS = 'DL_PROGRESS';
export const DL_STOP = 'DL_STOP';
export const DL_FAIL = 'DL_FAIL';



// WEBPACK FOOTER //
// ./src/constants/Downloader.js